import { initializeApp } from 'firebase/app';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';

export const config = {
    firebaseConfig: {
      apiKey: "AIzaSyBihvdVZIz38gzVdk0wozdPOkKZIMdOblI",
      authDomain: "craig-space-react.firebaseapp.com",
      projectId: "craig-space-react",
      storageBucket: "craig-space-react.appspot.com",
      messagingSenderId: "1081063147968",
      appId: "1:1081063147968:web:1381d63ee7d5fbc8e42025",
      measurementId: "G-7HGRPK8LP3"
      }
};

// Initialize Firebase
const app = initializeApp(config.firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// `yarn start:emulators` points the app at local emulators with sample data,
// so pages can be checked signed-in without touching real data.
if (process.env.REACT_APP_USE_EMULATORS === 'true') {
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
  connectAuthEmulator(getAuth(app), 'http://127.0.0.1:9099', {
    disableWarnings: true,
  });
  connectFunctionsEmulator(getFunctions(app), '127.0.0.1', 5001);
}

export { db };